import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client
export const supabaseClient = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storageKey: 'sb-auth-token',
    }
  }
); 